export const dataflowKeys = {
  all: ["dataflow"] as const,
  dataflow: (dataflowId: string) => [...dataflowKeys.all, dataflowId] as const,
  exchanges: (dataflowId: string) => [...dataflowKeys.all, dataflowId, "exchanges"] as const,
  project: (projectId: string) => [...dataflowKeys.all, projectId] as const,
};
